export default __webpack_public_path__ + "static/media/add.409fa269.webp";